export const SummaryMetricsIcons = [
  'blended',
  'tripleWhale',
  'pixel',
  'influencers',
  'shopify',
  'google',
  'googleAds',
  'googleAnalytics',
  'facebook',
  'klaviyo',
  'attentive',
  'tiktok',
  'pinterest',
  'snapchat',
  'youtube',
  'instagram',
  'gorgias',
  'enquirelabs',
  'kno',
  'recharge',
  'benchmarks',
  'amazon',
  'twitter',
  'microsoft',
  'customMetrics',
  'willy',
  'stripe',
  'mountain',
  'criteo',
  'shipstation',
  'smsbump',
  'shipbob',
  'postscript',
] as const;
